export default "__VITE_ASSET__JSjh8bPD__"